import React from 'react'

interface IGap {
  width?: string
  height?: string
}

const Gap = ({ width, height }: IGap) => {
  return <div style={{ width, height }} />
}

export default Gap
